module.exports = __webpack_public_path__ + "b793aac7e1ce4cffecfce10342a7c535.fbx";